import { Button, Grid } from "@material-ui/core"
import { ButtonGroupActionsProps } from "app/models/buttonGroup"
import Translation from "components/Translation"
import React from "react"

type buttonGroupType = {
  actions: ButtonGroupActionsProps[]
  formId?: string
}

const ButtonGroup = ({ actions, formId }: buttonGroupType) => (
  <Grid container={true} spacing={2} justifyContent="flex-end">
    {actions.map((action: ButtonGroupActionsProps, index: number) => (
      <Grid item={true} key={`popper-action-${index}`}>
        <Button
          color={action.color ? action.color : "secondary"}
          form={formId}
          size={action.size ? action.size : "medium"}
          variant={action.variant}
          {...action}
        >
          <Translation label={action.label} />
        </Button>
      </Grid>
    ))}
  </Grid>
)

export default ButtonGroup
